import { render, staticRenderFns } from "./AuthorityTypeModal.vue?vue&type=template&id=1b968fc8&scoped=true&"
import script from "./AuthorityTypeModal.vue?vue&type=script&lang=js&"
export * from "./AuthorityTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityTypeModal.vue?vue&type=style&index=0&id=1b968fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b968fc8",
  null
  
)

export default component.exports